<template>
  <div>
     <v-progress-linear
        :active="isLoading"
        :indeterminate="isLoading"
        absolute
        top
        color="#743063"
      ></v-progress-linear>
    <div class="hidden-sm-and-down">
      <div class="d-flex justify-center align-end">
        <div>
          <v-card max-width="600" class="ma-3">
            <v-img contain :src="item.thumbnailUrl"></v-img>
          </v-card>
        </div>
        <div>
          <ItemComponent :isInItemDetail="true" :showImage="false" :elevation="0" :itemProp="item"></ItemComponent>
        </div>
      </div>
    </div>

    <div class="hidden-md-and-up">
      <div class="d-flex justify-center">
        <ItemComponent :isInItemDetail="true" :elevation="0"  :itemProp="item"></ItemComponent>
      </div>
    </div>
    <div class="d-flex justify-center ma-2">
      <div v-html="item.description.arabic"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ItemComponent from "@/components/ItemComponent";
export default {
  name: "ItemDetail",

  //********************** */
  props: {
    id: {
      type: Number,
      default: -1,
    },
  },

  //********************** */
  components: {
    ItemComponent,
  },

  //********************** */
  data: () => ({
    showAddAgainDialog: false,
    isAddingToCart: false,
    isQuickDonating: false,
    amount: 0,
    quantity: 1,
    showError: false,
    rules: [(v) => v > 0 || "المبلغ يجب أن يكون أكثر من 0"],
    isLoading: false,
    currentImageUrl: "",
    item: {description:{arabic:""}},
  }),

  watch: {
    $route: "loadItemDetail",
  },

  //********************** */
  computed: {
    ...mapGetters("Catalog", {
      itemDetail: "itemDetail",
    }),
    ...mapGetters("Cart", {
      cart: "cart",
      cartItemsDictionary: "cartItemsDictionary",
    }),
    addToCartClass: function () {
      return this.cartItemsDictionary[this.item.id] == true ? "primary" : "";
    },
  },

  //********************** */
  methods: {
    loadItemDetail: async function () {
      this.isLoading = true;
      try {
        await this.$store.dispatch("Catalog/loadItemDetail", this.id);
        this.item = this.itemDetail;
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        alert(error);
      }
    },
    quickDonate: async function () {
      this.isQuickDonating = true;
      try {
        await this.$store.dispatch("Cart/addItem", {
          cartId: this.cart.id,
          quantity: this.quantity,
          itemId: this.item.id,
          amount: this.amount,
        });
      } catch (error) {
        this.showError = true;
        setTimeout(() => (this.showError = false), 3000);
        alert(error);
      }
      this.isQuickDonating = false;
      this.$store.dispatch("Cart/showDonate");
    },

    addToCart: async function () {
      if (
        this.showAddAgainDialog == false &&
        this.cartItemsDictionary[this.item.id] == true
      ) {
        this.showAddAgainDialog = true;
        return;
      }

      this.showAddAgainDialog = false;
      this.isAddingToCart = true;
      try {
        await this.$store.dispatch("Cart/addItem", {
          cartId: this.cart.id,
          quantity: this.quantity,
          itemId: this.item.id,
          amount: this.amount,
        });
      } catch (error) {
        this.showError = true;
        setTimeout(() => (this.showError = false), 3000);
        alert(error);
      }
      this.isAddingToCart = false;
    },
  },

  //*********************** */
  async created() {
    await this.loadItemDetail();
  },
};
</script>

<style>
</style>